export default (async () => {

  console.log('Loaded');

  let mobileNavToggler = document.querySelector<HTMLSelectElement>('.mobilenav-toggler');
  let mobileNavMenu = document.querySelector<HTMLSelectElement>('.mobile-nav-container');
  let mobileNavClose = document.querySelector<HTMLSelectElement>('#close-menu');
  let bodyTag = document.body;


  if (mobileNavToggler != null) {
    mobileNavToggler.addEventListener("click", toggleMenu);
  }

  if (mobileNavClose != null) {
    mobileNavClose.addEventListener("click", toggleMenu);
  }



  function toggleMenu() {

    if (mobileNavToggler != null && mobileNavMenu != null) {
      mobileNavToggler.classList.toggle("nav-close");
      mobileNavMenu.classList.toggle("show-menu");
      bodyTag.classList.toggle("mobile-menu--opened");
    }
  }

  let parentLinks = document.querySelectorAll('.parent-link');
  let childLists = document.querySelectorAll('.child-list');

  if (parentLinks) {
    [...parentLinks].forEach((parentLink) => {
      parentLink.addEventListener("click", () => {
        let currentMenuLink = parentLink.getAttribute('parent-link');

        parentLink.classList.toggle('selected-link');

        for (var l = 0; l < childLists.length; l++) {
          let currentChildList = childLists[l].getAttribute('child-links');
          if (currentChildList === currentMenuLink) {
            childLists[l].classList.toggle('show-list');
          }
          else {
            childLists[l].classList.remove('show-list');
          }
        }

        for (var x = 0; x < parentLinks.length; x++) {
          let currentMenuLinkAlt = parentLinks[x].getAttribute('parent-link');
          if (currentMenuLinkAlt !== currentMenuLink) {
            parentLinks[x].classList.remove('selected-link');
          }
        }

      })
    })
  }

   // Galleries


   let galleryFilters = document.querySelectorAll('.gallery-filter');
   let activeFilterGalleryId;
 
   for (var x = 0; x < galleryFilters.length; x++) {
 
     if (galleryFilters[x].classList.contains('active-filter')) {
       activeFilterGalleryId = galleryFilters[x].getAttribute('category-id');
     }
 
     showSelectedGallery(activeFilterGalleryId);
  
   }
 
 
   let currentURL = window.location.href;
 
   if (currentURL.includes('#')) {
 
     let galleryCategoryId = currentURL.split('#');
     let galleryCategoryIdSelected = galleryCategoryId[galleryCategoryId.length - 1];
    // console.log("HERE" + galleryCategoryIdSelected);

     for (var f = 0; f < galleryFilters.length; f++) { 
      galleryFilters[f].classList.remove('active-filter');

     // console.log("Loop : " + f);

      if (galleryFilters[f].getAttribute('category-id') === galleryCategoryIdSelected) {
        galleryFilters[f].classList.add('active-filter');
      }
    }
 
     showSelectedGallery(galleryCategoryIdSelected);
 
   }


  if (galleryFilters) {
    [...galleryFilters].forEach((galleryFilter) => {
      galleryFilter.addEventListener("click", () => {
        let galleryFilterId = galleryFilter.getAttribute('category-id');


        for (var x = 0; x < galleryFilters.length; x++) {
          galleryFilters[x].classList.remove('active-filter');
        }

        galleryFilter.classList.add('active-filter');

        showSelectedGallery(galleryFilterId);


      })
    })
  }



  // Controls the Gallery and Which One is Visible

  function showSelectedGallery(galleryFilterId: any) {
  //  console.log("show : " + galleryFilterId);
    let galleries = document.querySelectorAll('.gallery');

    for (var l = 0; l < galleries.length; l++) {
      let currentGallery = galleries[l];

      let currentGalleryId = currentGallery.getAttribute('category-id');

      if (currentGalleryId === galleryFilterId) {
        currentGallery.classList.add('active-gallery');
      }
      else {
        currentGallery.classList.remove('active-gallery');
      }
    }
  }




  let homepageBanner = document.querySelector('.banner-three');

  let maxImages = homepageBanner?.getAttribute('num-blocks');

  function getRandomInt(max: any) {
    return Math.floor(Math.random() * max);
  }


  console.log(getRandomInt(maxImages));

  let randomNumber = getRandomInt(maxImages);

  if (!isNaN(randomNumber)) {

  let centerImages = document.querySelectorAll('.banner-center-image');

  centerImages[randomNumber].classList.remove('d-none');

  }



})();